import { render } from "./AttrButton.vue?vue&type=template&id=49fc565a"
import script from "./AttrButton.vue?vue&type=script&lang=js"
export * from "./AttrButton.vue?vue&type=script&lang=js"

import "./AttrButton.vue?vue&type=style&index=0&id=49fc565a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49fc565a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49fc565a', __exports__)) {
    api.reload('49fc565a', __exports__)
  }
  
  module.hot.accept("./AttrButton.vue?vue&type=template&id=49fc565a", () => {
    api.rerender('49fc565a', render)
  })

}


export default __exports__